export const getAddonIdsByProductSpecContainmentID = (
  productSpecContainmentID,
  availableAddons = {}
) => {
  let selectedAddons = [];
  const availableAddonsValues = Object.values(availableAddons);
  const availableAddonsKeys = Object.keys(availableAddons);

  for (let i = 0; i < availableAddonsValues.length; i++) {
    if (
      availableAddonsValues[i].productSpecContainmentID ===
      productSpecContainmentID
    ) {
      selectedAddons.push(availableAddonsKeys[i]);
    }
  }

  return selectedAddons;
};

export const getTradeInSelection = (dataSource = []) => {
  const brands = dataSource.map(data => ({
    text: data.title,
    value: data.value
  }));
  const modelByBrand = dataSource.reduce((acc, cur) => {
    return {
      ...acc,
      [cur.title]: cur.models.map(model => ({
        text: `${model.title} - $${model.tradeinPrice}`,
        value: model.value,
        tradeinPrice: model.tradeinPrice
      }))
    };
  }, {});

  return {
    brands,
    modelByBrand
  };
};
